/**
 * Гвард не дает вводить ничего кроме целых чисел
 * @param value
 */
export var intGuard = function intGuard(value) {
  return value.replace(/[^0-9]/, '');
};